const ShipmentCode = `
  id
  description
  definition
  ccImport
  updatedAt
`;

export default ShipmentCode;
